import { Component, Input, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AsyncPipe } from "@angular/common";

@Component({
	selector: "svg-inline",
	templateUrl: "./svg-inline.component.html",
	styleUrls: ["./svg-inline.component.scss"],
	imports: [AsyncPipe],
	standalone: true
})
export class SvgInlineComponent implements OnInit {
	@Input() src!: string;
	@Input() class: string;
	@Input() alt: string;
	svgIcon$!: Observable<SafeHtml>;

	constructor(
		private http: HttpClient,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit(): void {
		this.svgIcon$ = this.http
			.get(this.src, { responseType: "text", reportProgress: false })
			.pipe(map((svgText) => this.sanitizer.bypassSecurityTrustHtml(svgText)));
	}
}
